<div class="related-element list-products" *skeleton="selectedSupplier == null; height: '164px'; width: '100%'; margin:'0 auto 0px';">
    <div class="top-part">
        <span class="title">{{"LIST OF PRODUCTS" | translate}}</span>
    </div>
    <div class="product" *ngIf="roleAuth?.modifySupplierQuality">
        <input #addProductInput type="text" class="form-control" [(ngModel)]="productInput" placeholder="{{'ADD A PRODUCT' | translate}}" (keyup.enter)="addProduct()" autocomplete="off">
        <mat-icon class="mat-icon-rtl-mirror" (click)="addProduct()">{{'add_circle'}}</mat-icon>
    </div>
    <div class="product" *ngFor="let v of selectedSupplier?.supplierQualityProducts"> 
        <span><strong>{{v.productName}}</strong></span>
        <mat-icon class="mat-icon-rtl-mirror" *ngIf="roleAuth?.modifySupplierQuality" (click)="openRemoveProductPopup(v)">{{'do_not_disturb_on'}}</mat-icon>
    </div>
</div>

<app-single-action-popup
            [isPopupOpen]="productToRemove != null"
            title="{{'REMOVE THIS PRODUCT' | translate}}"
            description="{{'REMOVE PRODUCT MESSAGE' | translate}}"
            actionText="{{'REMOVE' | translate}}"
            (closePopupEvent)="closePopup()"
            (actionPopupEvent)="removeProduct()"
/>
